<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="40"
		height="40"
		viewBox="0 0 40 40"
		fill="none"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M20 36.6667C29.2047 36.6667 36.6666 29.2048 36.6666 20C36.6666 10.7953 29.2047 3.33337 20 3.33337C10.7952 3.33337 3.33331 10.7953 3.33331 20C3.33331 29.2048 10.7952 36.6667 20 36.6667Z"
			fill="#FF0303"
		/>
		<rect
			x="18.3333"
			y="11.6666"
			width="3.33333"
			height="13.3333"
			rx="1"
			fill="white"
		/>
		<rect
			x="18.3333"
			y="26.6666"
			width="3.33333"
			height="3.33333"
			rx="1"
			fill="white"
		/>
	</svg>
</template>

<script>
export default {
	name: 'EventWithGaWarning',
};
</script>
